import axios from 'axios';
import { Cookies } from 'react-cookie';
import { API_URL } from '../variables';

const cookie = new Cookies();

function getHeaders() {
  return {
    headers: {
      authorization: cookie.get('userToken'),
    },
  };
}

// POST

function login(userData) {
  return axios.post(`${API_URL}/login`, userData).then(({ data }) => data);
}

function registerUser(userData) {
  return axios.post(`${API_URL}/register`, userData).then(({ data }) => data);
}

function recoverPassword(recoveryEmail) {
  return axios
    .post(`${API_URL}/forgot-password`, { email: recoveryEmail })
    .then(({ data }) => data);
}

function logout() {
  return axios.post(`${API_URL}/logout`, {}, getHeaders()).then(({ data }) => data);
}

function changeLogin(userData) {
  const {
    email,
    oldPassword,
    newPassword: password,
    confirmPassword: passwordConfirm,
  } = userData;

  return axios
    .post(
      `${API_URL}/user/update/login`,
      { email, oldPassword, password, passwordConfirm },
      getHeaders()
    )
    .then(({ data }) => data);
}

export {
  getHeaders,
  login,
  registerUser,
  recoverPassword,
  logout,
  changeLogin,
};
